import React from "react";
import SecTitle from "../Common/SecTitle";
import { Tooltip } from "react-tooltip";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
const PopularSite = () => {
  return (
    <section className="container pb-5 rounded-3 blur_bg">
      <SecTitle title="سایت های پر تکرار" />
      <Tooltip id="my-tooltip" />
      <div className="row justify-content-center text-center mx-0">
        <div className="col-1 mb-3"> </div>
        <div className="col-3 mb-3">
          <a
            href="https://github.com"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="github"
            target="_blank"
          >
            {/* <i className="fa fa-github fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-github (1).svg" />
          </a>
        </div>
        <div className="col-3  mb-3 ">
          <a
            href="https://about.gitlab.com/"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="gitlab"
            target="_blank"
          >
            {/* <i className="fa fa-pinterest fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-gitlab (1).svg" />
          </a>
        </div>
        <div className="col-3 mb-3">
          <a
            href="https://marketplace.atlassian.com/apps/1220925/custom-charts-for-jira-reports?hosting=cloud&tab=overview&utm_source=google&utm_medium=paid&utm_campaign=Custom_Charts_Search_Ads&utm_content=Custom_Charts_Search_Ads&utm_term=jira&hsa_acc=3457323696&hsa_cam=2038731244&hsa_grp=71735801163&hsa_ad=648970578872&hsa_src=g&hsa_tgt=kwd-50196867&hsa_kw=jira&hsa_mt=b&hsa_net=adwords&hsa_ver=3&gclid=CjwKCAjwrdmhBhBBEiwA4Hx5g69sIx2Mt5XrqxCIK-91wBCIk-dT8DotXsLoSseUSzHPmzBMCaf8FRoCcVoQAvD_BwE"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="atlassian"
            target="_blank"
          >
            {/* <i className="fa fa-gitlab fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-jira.svg" />
          </a>
        </div>
        <div className="col-1 mb-3"></div>
        <div className="col-3 mb-3">
          <a
            href="https://www.pinterest.com/"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="pinterest"
            target="_blank"
          >
            {/* <i className="fa fa-font-awesome fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-pinterest (1).svg" />
          </a>
        </div>
        <div className="col-3 mb-3">
          <a
            href="https://www.postman.com/"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="postman"
            target="_blank"
          >
            {/* <i className="fa fa-youtube fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-postman-is-the-only-complete-api-development-environment-48.png" />
          </a>
        </div>
        <div className="col-3 mb-3">
          <a
            href="https://stackoverflow.com/"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="stackoverflow"
            target="_blank"
          >
            {/* <i className="fa fa-linkedin fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-stack-overflow.svg" />
          </a>
        </div>
        <div className="col-3 mb-3">
          <a
            href="https://trello.com/"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="trello"
            target="_blank"
          >
            {/* <i className="fa fa-instagram fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-trello.svg" />
          </a>
        </div>
        <div className="col-1 mb-3"></div>
        <div className="col-3 mb-3">
          <a
            href="#"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="github"
            target="_blank"
          >
            {/* <i className="fa fa-whatsapp fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-trello.svg" />
          </a>
        </div>
        <div className="col-3 mb-3">
          <a
            href="https://www.linkedin.com/"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="linkedin"
            target="_blank"
          >
            {/* <i className="fa fa-linkedin fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-linkedin-circled.svg" />
          </a>
        </div>
        <div className="col-3 mb-3">
          <a
            href="https://dribbble.com/"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="dribbble"
            target="_blank"
          >
            {/* <i className="fa fa-font-awesome fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-dribbble.svg" />
          </a>
        </div>
        <div className="col-1 mb-3"></div>
        <div className="col-3 mb-3">
          <a
            href="https://codepen.io/"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="codepen"
            target="_blank"
          >
            {/* <i className="fa fa-linkedin fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-codepen.svg" />
          </a>
        </div>
        <div className="col-3 mb-3">
          <a
            href="http://www.codecademy.com/"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="codecademy"
            target="_blank"
          >
            {/* <i className="fa fa-github fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-codecademy-an-online-platform-offers-free-coding-classes-programming-languages-48.png" />
          </a>
        </div>
        <div className="col-3 mb-3">
          <a
            href="https://medium.com/"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="medium"
            target="_blank"
          >
            {/* <i className="fa fa-whatsapp fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-medium.svg" />
          </a>
        </div>
        <div className="col-3 mb-3">
          <a
            href="#"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="https://github.com"
            target="_blank"
          >
            {/* <i className="fa fa-github fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-freecodecamp-a-non-profit-organization-that-consists-of-an-interactive-learning-web-platform-48.png" />
          </a>
        </div>
        <div className="col-1 mb-3"></div>
        <div className="col-3 mb-3">
          <a
            href="https://www.freecodecamp.org/"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="freecodecamp"
            target="_blank"
          >
            {/* <i className="fa fa-pinterest fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-hacker-news.svg" />
          </a>
        </div>
        <div className="col-3 mb-3">
          <a
            href="https://www.jetbrains.com/"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="jetbrains"
            target="_blank"
          >
            {/* <i className="fa fa-font-awesome fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-jetbrains-toolbox.svg" />
          </a>
        </div>
        <div className="col-3 mb-3">
          <a
            href="https://leetcode.com/"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="leetcode"
            target="_blank"
          >
            {/* <i className="fa fa-github fa-3x text-muted"></i> */}
            <img src="images/site_icons/icons8-level-up-your-coding-skills-and-quickly-land-a-job-48.png" />
          </a>
        </div>
        <div className="col-1 mb-3"></div>
      </div>
    </section>
  );
};

export default PopularSite;
